var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { when } from "lit/directives/when.js";
import base from "../../styles/utility/baseline.css?type=raw";
import { frontmatterIsSet } from "../../utils/index.ts";
import { consolewriter } from "../../utils/lit.ts";
import "../console-writer/console-writer.ts";
import header from "./header.css?type=raw";
/** View transition duration in ms. */
const transitionDuration = 250;
let PageHeader = class PageHeader extends LitElement {
    constructor() {
        super(...arguments);
        this.header = "";
        this.subtitle = "${unset}";
    }
    static { this.styles = [unsafeCSS(base), unsafeCSS(header)]; }
    render() {
        const { header, subtitle } = this;
        const headerDuration = consolewriter.getDuration(header);
        return html `
      <header>
        <hgroup>
          <console-writer
            role="heading"
            aria-level="1"
            class="headline2"
            text="${header}"
            delay=${transitionDuration}
          ></console-writer>
          ${when(frontmatterIsSet(subtitle), () => html `
              <console-writer
                text="${subtitle}"
                delay=${headerDuration + transitionDuration}
                class="headline5"
              ></console-writer>
            `)}
        </hgroup>
      </header>
    `;
    }
};
__decorate([
    property({ type: String })
], PageHeader.prototype, "header", void 0);
__decorate([
    property({ type: String })
], PageHeader.prototype, "subtitle", void 0);
PageHeader = __decorate([
    customElement("page-header")
], PageHeader);
export default PageHeader;
